import { Form, Input } from "antd";
import { useEffect } from "react";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import { DeleteOutlined } from "@ant-design/icons";
import InvestigationSearchList from "./InvestigationSearchList";
const AiInvestigationForm = ({ form, editData, onLastDelete }) => {
  useEffect(() => {
    if (editData?.investigations) {
      form.setFieldsValue({
        ...editData,
        investigations: editData?.investigations,
      });
    }
  }, [editData?.investigations]);
  return (
    <Form.List name="investigations">
      {(fields, { remove }) =>
        fields.map((field) => (
          <div key={field.key} style={{ display: "flex", gap: "12px" }}>
            <div style={{ flexGrow: 1 }}>
              <InvestigationSearchList field={field} form={form} />

              <Form.Item
                name={[field.name, "comments"]}
                label="Add Notes"
                style={{ marginTop: 20 }}
              >
                <Input.TextArea
                  rows={1}
                  style={{ width: "500px" }}
                  className={inputStyles.mdInput}
                />
              </Form.Item>
            </div>

            <DeleteOutlined
              onClick={() => {
                remove(field.name);
                if (fields.length === 1) onLastDelete();
              }}
              style={{ color: "red", fontSize: 20, cursor: "pointer" }}
            />
          </div>
        ))
      }
    </Form.List>
  );
};
export default AiInvestigationForm;
